
import React, { useMemo, useRef, useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import SweetAlert2 from 'react-sweetalert2';
import SAlert from '../../shared/SAlert';
import useUtils from '../../../../utiles/useUtiles';
import Footer from '../../../components/Footer';

import ModalAddTemplateType from '../../../components/ModalAddTemplateType';

const TemplateTypeList: React.FC = () => {

    const navigate = useNavigate();
    const [showAddTemplateTypeModal, setShowAddTemplateTypeModal] = useState<boolean>( false );
    const [searchParams, setSearchParams] = useState<any>( { searchText: '' } );
    const [templateTypeList, setTemplateTypeList] = useState<any>( { count: 0, rows: [] } );
    const [loading, setLoading] = useState<boolean>( false );
    const [selectedTemplateType, setSelectedTemplateType] = useState<any | null>( null );
    const [showDeleteAlert, setShowDeleteAlert] = useState<boolean>( false );
    const [pagination, setPagination] = useState<any>( {
        pageIndex: 0,
        pageSize: 10
    } );
    const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    useEffect( () => {
        fetchTemplateTypes();
    }, [pagination.pageIndex, pagination.pageSize] );

   
    const columns = useMemo(
        () => [
          {
            accessorKey: 'name',
            header: 'Template Type Name',
            minSize: 50,
            maxSize: 120,
            Cell: ( { cell }: any ) => <span>{cell.getValue()}</span>,
          },
          {
            accessorKey: 'status',
            header: 'Status',
            minSize: 50,
            maxSize: 120,
            Cell: ( { cell } ) => <span>{cell.getValue() == 1 ? 'Active' : 'Inactive'}</span>,
          },
          {
            accessorKey: 'actions',
            header: 'Action',
            minSize: 30,
            maxSize: 60,
            Cell: ( { cell } ) => <div>
                <FontAwesomeIcon
                    title='View'
                    icon={faEye}
                    className="isPointer ml-2 cursor-pointer"
                    onClick={() => navigate( `/csv-tool/template-types/${cell.row.original.id}` )}
                />&nbsp;
                <FontAwesomeIcon
                    title='Remove'
                    icon={faTrash}
                    className="isPointer ml-2 text-danger cursor-pointer"
                    onClick={() => confirmDelete( cell.row.original )}
                />
            </div>,
          }
        ],
        [],
    );

    const closeModal = () => {
        setShowAddTemplateTypeModal( false );
        fetchTemplateTypes();
    };

    const onSearchChange = ( field: string, value: string ) => {
        setSearchParams( {
          ...searchParams,
          [field]: value
        } );
      };

    const fetchTemplateTypes = async () => {
        setLoading( true );
        const searchString = Object.keys( searchParams )
        .filter( key => searchParams[key] )
        .map( key => `${key}=${searchParams[key]}` ).join( '&' );

        const request = await axios.get( `${baseUrl()}/template_types?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&${searchString}` );
        const { error, message, result } = request.data;
        setLoading( false );
        if ( error ) {
            toast.error( message );
        } else {
            setTemplateTypeList( result );
        }
    };

    const confirmDelete = ( templateType: any ) => {
        setSelectedTemplateType( templateType );
        setShowDeleteAlert( true );
    };

    const handleDelete = async () => {
        setLoading( true );
        const request = await axios.delete( `${baseUrl()}/template_types/${selectedTemplateType.id}` );
        setLoading( false );
        const { error, result, message } = request.data;
    
        if ( error ) {
            toast.error( message || 'Error to delete the record' );
        } else {
            fetchTemplateTypes();
            setSelectedTemplateType( null );
            setShowDeleteAlert( false );
        }
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="main-container">
                          <div className="main-container-inner">
                            {/* <div className="logo mb-3"><img src="logo-min.png" /></div> */}
                            <div className="main-card revrex-data-table-card">
                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    <h1 className='page-title-sm'>Template Type List</h1>
                                    <button data-cy="btnAddTemplateTypeList" className='btn btn-md btn-custom-secondary' onClick={() => setShowAddTemplateTypeModal( true )}>
                                        Add
                                    </button>
                                </div>
                                <div className='mb-4 d-flex gap-10'>
                                    <div className='flex-grow-1'>
                                        <input type={"text"} name="searchText" placeholder="Template type name" className="form-control" autoComplete='new-password' onChange={( e ) => onSearchChange( 'searchText', e.target.value )} />
                                    </div>
                                    <div className=''>
                                        <button type="button" className="btn btn-md btn-custom-secondary" onClick={fetchTemplateTypes}>Search</button>
                                    </div>
                                </div>
                                <MaterialReactTable 
                                    columns={columns} 
                                    data={templateTypeList?.rows} 
                                    rowCount={templateTypeList?.count} 
                                    enableColumnOrdering={false} 
                                    enableRowSelection={false} 
                                    enableSelectAll={false}
                                    enableColumnActions={false}
                                    manualPagination
                                    onPaginationChange={setPagination}
                                    state={{ pagination }}
                                    enableSorting={false}
                                    enableGlobalFilter={false}
                                    enableFullScreenToggle={false}
                                    enableDensityToggle={false}
                                    enableHiding={false}
                                    enableColumnFilters
                                    enableFilters={false}
                                />
                                <SAlert
                                    show={showDeleteAlert}
                                    showCancel
                                    confirmBtnText="Yes"
                                    cancelBtnText="No"
                                    confirmBtnBsStyle="primary"
                                    cancelBtnBsStyle="secondary"
                                    onCancel={() => setShowDeleteAlert( false )}
                                    title={`Delete Record`}
                                    msg={`Are you sure to delete the template type, ${selectedTemplateType?.name}?`}
                                    onConfirm={() => handleDelete()}
                                />
                            </div>
                          </div>
                          <Footer />
                        </div>
                    </div>
                </div>
            </div>
            { showAddTemplateTypeModal && <ModalAddTemplateType show={showAddTemplateTypeModal} handleClose={closeModal} />}
            {loadingScreen( loading )}
        </>
    );
}

export default TemplateTypeList